import React, { useCallback, useState } from 'react';
import classes from './style.module.scss';
import { PERMISSION_GROUPS } from '~/accessControl/permissionGroups';
import AccessControl from '~/accessControl';
import Button from '~/app/common/Button';
import { useStoreActions, useStoreState } from '~/store';
import useTranslation from '~/app/hooks/useTranslation';
import { APIResponse, ServiceDetails, ServiceSavePayload } from '~/types';
import CompleteService from '~/services/CompleteService';
import { useHistory } from 'react-router';
import { route } from '~/app/helpers/route';
import { ROUTES } from '~/app/Router';
import { notify } from '~/app/helpers/notify';

export type CompleteServiceDialogComponent = React.FC;

const CompleteServiceDialog = () => {
    const { t } = useTranslation('serviceChecklist');
    const { t: tIssue } = useTranslation('issue');
    const { t: tService } = useTranslation('service');
    const history = useHistory();
    const [isOpenCloseServiceForm, setIsOpenCloseServiceForm] = useState<boolean>(false);
    const serviceDetails = useStoreState(state => state.service.data);
    const fetching = useStoreState(state => state.serviceCheck.fetching);
    const isChecksDataUpdated = useStoreState(state => state.serviceCheck.isChecksDataUpdated);
    const setShowCompleted = useStoreActions(actions => actions.service.setShowCompleted);
    const saveServiceAction = useStoreActions(actions => actions.service.saveService);
    const checksData = useStoreState(state => state.serviceCheck.checksData);
    const userName = useStoreState(state => state.user.data.name);;

    const closeServiceClickHandler = useCallback((state: boolean) => (): void => {
        setIsOpenCloseServiceForm(state);
    }, []);

    const fetchServiceDetails = useCallback(async (id: ServiceDetails['id']) => {
        setShowCompleted(true);
        history.length > 1 ? history.goBack() : history.push(route(ROUTES.projects));
    }, [setShowCompleted, history]);

    const saveServiceClickHandler = useCallback(() => {
        const serviceId = serviceDetails.id;
        const workOrderId = serviceDetails.workOrderId;

        const payload: ServiceSavePayload = {
            ...(serviceId && { serviceId }),
            ...(workOrderId && { workOrderId }),
            checklist: checksData
        } as ServiceSavePayload;
        
        saveServiceAction(payload).then(async (data: APIResponse) => {
            if (data.success && serviceId) {
                notify(tService(`success.saved`), 'success');
            } else {
                notify(tIssue(`error.${data?.msg}`, {userName: data?.msg && data.msg === 'userAlreadyExistForSelectedDate' ? userName : ''}), 'error');
            }

        });
    }, [checksData, saveServiceAction, serviceDetails.id, serviceDetails.workOrderId, tIssue, tService, userName])

    const back = useCallback(() => {
        history.length > 1 ? history.goBack() : history.push(route(ROUTES.projects));
    }, [history]);

    return (
        <>
            <AccessControl requiredPermissions={PERMISSION_GROUPS.writeServiceDetails} >
                <div className={`${classes['footer']}`}>
                    <Button className={`${classes['abort']}`} onClick={back}> {t('cancel')} </Button>
                    <Button
                        loading={fetching}
                        className={classes['saveChecklist']}
                        onClick={saveServiceClickHandler}
                    >
                        {t('temporary')}
                    </Button>
                    <Button
                        loading={fetching}
                        className={classes['submit']}
                        onClick={closeServiceClickHandler(true)}
                        disabled={!isChecksDataUpdated}
                    >
                        {t('complete')} 
                    </Button>
                </div>
                <CompleteService open={isOpenCloseServiceForm} onClose={closeServiceClickHandler(false)} serviceDetails={serviceDetails} onSave={fetchServiceDetails} />
            </AccessControl>
        </>
    );
};


export default CompleteServiceDialog;